import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { TokenProvider } from "./context/TokenContext";

let root = null;

function init(options = {}) {
  if (document.getElementById("trudoc-video-widget")) return;
  // console.log("Initializing TruDoc Video Widget");

  const container = document.createElement("div");
  container.id = "trudoc-video-widget";

  // Attach Shadow DOM
  const shadowRoot = container.attachShadow({ mode: "open" });
  document.body.appendChild(container);

  const globalStyle = document.createElement("style");
  globalStyle.textContent = `
  #end-for-all-button,
#leave-meeting-button {
  display: block !important;
  width: 100% !important;
  margin: 0 !important;
}

/* Force vertical stacking by making parent a flex column container */
#end-for-all-button:parent,
#leave-meeting-button:parent {
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important; /* adds space between buttons */
}

/* If the above doesn't work, use the actual parent selector combo */
#end-for-all-button,
#leave-meeting-button {
  display: block !important;
  width: 100% !important;
  margin: 0 !important;
}

// #end-for-all-button + #leave-meeting-button {
//   margin-top: 8px !important; /* adds vertical spacing */
// }
  
  #end-for-all-button {
    background-color: #dc2626 !important;
    color: #ffffff !important;
    border: 2px solid #b91c1c !important;
    // border-radius: 0.5rem !important;
    font-weight: 600 !important;
    transition: background-color 0.2s ease-in-out;
  }

  #end-for-all-button:hover {
    background-color: #b91c1c !important;
  }

  #leave-meeting-button {
    background-color: transparent !important;
    color: #dc2626 !important;
    border: 2px solid #fecaca !important;
    // border-radius: 0.5rem !important;
    font-weight: 500 !important;
    transition: background-color 0.2s ease-in-out;
  }

  #leave-meeting-button:hover {
    background-color: #fef2f2 !important;
  }

  #reclaim-host-button{
  display: none !important;
  }
`;
  document.head.appendChild(globalStyle);

  const shadowContainer = document.createElement("div");
  shadowRoot.appendChild(shadowContainer);

  // Inject CSS into Shadow DOM
  const style = document.createElement("style");
  style.textContent = `
    /* Add your widget-specific styles here */
    #trudoc-video-widget, #trudoc-video-widget * {
      box-sizing: border-box;
    }

    /* Example styles for the widget */
    div {
      font-family: Arial, sans-serif;
      color: #333;
    }

    button {
      background-color: #007bff;
      color: white;
      border: none;
      padding: 10px 20px;
      cursor: pointer;
    }
  `;
  shadowRoot.appendChild(style);

  // Fetch and inject external CSS into Shadow DOM
  fetch("trudoc-video-widget/dist/trudoc-video.css") // Adjust the path if needed
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to load CSS: ${response.statusText}`);
      }
      return response.text();
    })
    .then((css) => {
      const externalStyle = document.createElement("style");
      externalStyle.textContent = css;
      shadowRoot.appendChild(externalStyle);
    })
    .catch((error) => {
      console.error("Error loading external CSS:", error);
    });

  // Render React app inside the shadowContainer
  root = ReactDOM.createRoot(shadowContainer); // Use shadowContainer here
  root.render(
    <TokenProvider>
      <App options={options} />
    </TokenProvider>
  );
  // console.log("TruDoc Video Widget initialized");

  const authToken = options.authToken;

  if (authToken) {
    window.__initialTruDocToken = authToken;
  }
}

function startCall(webRoomUrl) {
  // console.log("Starting call with session ID:", webRoomUrl);
  window.dispatchEvent(
    new CustomEvent("start-call", { detail: { webRoomUrl } })
  );
}

function endCall() {
  // console.log("Ending call");
  window.dispatchEvent(new Event("end-call"));
}
function incomingCall(webRoomUrl) {
  // console.log("Incoming call", webRoomUrl);
  window.dispatchEvent(
    new CustomEvent("incoming-call", { detail: { webRoomUrl } })
  );
}

function logoutFromVideoCall() {
  // console.log("Ending call");
  window.dispatchEvent(new Event("logout-video-call"));
}
function patientCancelledCall() {
  // console.log("patientCancelledCall");
  window.dispatchEvent(new Event("patient-cancelled-call"));
}
// function declineCall() {
//   console.log("Decline call");
//   window.dispatchEvent(new Event("decline-call"));
// }

window.TruDocVideo = {
  init,
  startCall,
  endCall,
  incomingCall,
  logoutFromVideoCall,
  patientCancelledCall
};
